/**
 * App-wide interaction type constants for trackInteraction.
 *
 * These are the `type` values in InteractionEvent. Defined here so every
 * feature uses the same strings and they're grep-able for analytics.
 */
export const INTERACTION_TYPES = {
  pageViewed: 'page_viewed',
  actionTriggered: 'action_triggered',
  filterUsed: 'filter_used',
  searchExecuted: 'search_executed',
  searchFocused: 'search_focused',
  cardTapped: 'card_tapped',
  infiniteScrollPageLoaded: 'infinite_scroll_page_loaded',
} as const;
